
export const colorPrimary = () => 'var(--color-primary)';
export const colorPrimaryDark = () => 'var(--color-primary-dark)';
export const colorPrimaryStatic = () => 'var(--color-primary-static)';
export const colorPrimaryDarkStatic = () => 'var(--color-primary-dark-static)';
export const colorLightGreen = () => 'var(--color-light-green)';
export const colorPrimaryDarkAlpha = () => 'var(--color-primary-dark-alpha)';
export const colorGreenPale = () => 'var(--color-green-pale)';
export const colorLightGrey = () => 'var(--color-light-grey)';
export const colorDark = () => 'var(--color-dark)';
export const colorLight = () => 'var(--color-light)';
export const colorGrey = () => 'var(--color-grey)';
export const colorYellowStrong = () => 'var(--color-yellow-strong)';
export const colorYellowMedium = () => 'var(--color-yellow-medium)';
export const colorYellowLight = () => 'var(--color-yellow-light)';
export const colorRed = () => 'var(--color-red)';
export const colorPurpleDark = () => 'var(--color-purple-dark)';
export const colorDarkBlue = () => 'var(--color-dark-blue)';
export const colorPrimaryPale = () => 'var(--color-primary-pale)';
export const colorLightGrey2 = () => 'var(--color-light-grey2)';
export const colorTurquoise60 = () => 'var(--color-turquoise-60)';

// These colors are not defined as CSS variables, so keep them as constants:
export const colorGreen300 = "#ABE220";
export const colorGreen500 = "#6FB62C";
export const colorGreen700 = "#16a34a"
export const colorApple050 = "#D2DA55";
export const colorGold600 = "#DABB55";
export const colorBrown200 = "#D2A371";
